import dynamic from 'next/dynamic';
import { Container, MapTo } from '@adobe/aem-react-editable-components';
/* eslint-disable @nx/enforce-module-boundaries */
import '../../libs/aemComponents/Container'; // TODO: Why are these imports not aliased?
import '../../libs/aemComponents/ExperienceFragment';
import { getAllowedComponentsForNonAuthorMode as getAllowedComponentsUtil } from '@marriott/shared/mi-helper-utils';
import {
  EditableHTLWrapper,
  StaticWrapper,
  CardHorizontalMini,
  CardLayered,
  CardVertical,
  CardCarouselContainer,
  CardHorizontalFeature,
  BannerLayered,
  BrandRibbon,
  IconBlock,
  AccordionContainer,
  LinkBanner,
  CobrandCardHorizontalFlexible,
  Hero,
  Footer,
  LinkList,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  GeneralMessage,
  ProtectedContainer,
} from '@marriott/mi-common-static-components';
/* eslint-enable @nx/enforce-module-boundaries */
import {
  AEMText,
  SearchFormEditable,
  NGSearchFormEditable,
  NGSearchFormABTestWrapper as SearchformContainer,
} from '@marriott/mi-shop-components';
import { OfferCardCarousel } from '@marriott/mi-offers-components';
import {
  CarouselContainerSkeletonLoader,
  BannerLayeredSkeletonLoader,
  CardHorizontalMiniSkeletonLoader,
  HeroBanner,
  IconFeatureBanner,
  PropertyBarWrapper,
  StickyComponentWrapper,
  Postcard,
  PostcardContainer,
  ThemeCluster,
  ThemeClusterCarousel,
  ProductDetailsCard,
  SixPackContainer,
  TabbedLayout,
  DynamicTabbedLayout,
  EnrollmentCardContainer,
  CNAnimatedBanner,
  POLARIS_CONSTANTS,
} from '@marriott/mi-homepage-components';
import {
  MerchandisingSmallBanner,
  MerchandisingHeroBanner,
  MerchandisingDCAContainer,
  DCADecisionContainer,
  RiottMediaCard,
  MerchandisingCarouselContainer,
  MerchandisingCardTile,
  MerchandisingEyebrowBanner,
} from '@marriott/mi-merch-components';
import { AccountContainerEditable, SignInEditable, SignInContentBlockEditable } from '@marriott/mi-account-components';
import { DynamicDCAComponentProvider, respGridUtil } from '@marriott/mi-headless-utils';
const HQVModalEditableMGP = dynamic(
  () => import('@marriott/mi-book-components').then(module => module.HQVModalEditableMGP),
  { ssr: true }
);

const HotelOverview = dynamic(() => import('@marriott/mi-book-components').then(module => module.HotelOverview), {
  ssr: true,
});

const HotelInformation = dynamic(() => import('@marriott/mi-book-components').then(module => module.HotelInformation), {
  ssr: true,
});

const HotelGalleryTitle = dynamic(
  () => import('@marriott/mi-book-components').then(module => module.HotelGalleryTitle),
  {
    ssr: true,
  }
);

const HotelGalleryPhotoViewer = dynamic(
  () => import('@marriott/mi-book-components').then(module => module.HotelGalleryPhotoViewer),
  { ssr: true }
);

const CardCarouselContainerDynamic = dynamic(
  () => import('@marriott/mi-common-static-components').then(module => module.CardCarouselContainer),
  {
    ssr: true,
    loading: () => <CarouselContainerSkeletonLoader />,
  }
);

const CardHorizontalMiniDynamic = dynamic(
  () => import('@marriott/mi-common-static-components').then(module => module.CardHorizontalMini),
  {
    ssr: true,
    loading: () => <CardHorizontalMiniSkeletonLoader />,
  }
);

const BannerLayeredDynamic = dynamic(
  () => import('@marriott/mi-common-static-components').then(module => module.BannerLayered),
  {
    ssr: true,
    loading: () => <BannerLayeredSkeletonLoader />,
  }
);

const FooterDynamic = dynamic(() => import('@marriott/mi-common-static-components').then(module => module.Footer), {
  ssr: true,
});

const FlyoutDrawerDynamic = dynamic(() => import('@marriott/mi-book-components/molecules').then(m => m.FlyoutDrawer), {
  ssr: true,
  loading: () => null,
});

export const NGSearchFormABTestWrapper = props => {
  return <DynamicDCAComponentProvider Component={SearchformContainer} props={props} />;
};

// TODO: AEM component paths are having issues when picked using ENV vars
// Needs to be investigated as tech debt
export const AEM_REACT_MAPPING = {
  ['mi-aem-common-spa/components/content/generalmessage']: GeneralMessage,
  [`mi-aem-homepage-spa/components/text`]: AEMText,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-homepage-spa/components/content/herobanner`]: HeroBanner,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  [`mi-aem-common-spa/components/content/brandribbon`]: BrandRibbon,
  [`mi-aem-common-spa/components/content/linkbanner`]: LinkBanner,
  [`mi-aem-common-spa/components/content/linklist`]: LinkList,
  [`mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch`]: SearchFormEditable,
  [`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`]: SearchFormEditable,
  [`mi-aem-shop-spa/components/content/ngsearchform/v1/ngsearchform`]: NGSearchFormEditable,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/accordioncontainer`]: AccordionContainer,
  [`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`]: CobrandCardHorizontalFlexible,
  [`mi-aem-offers-spa/components/offers-cards`]: OfferCardCarousel,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/content/hero`]: Hero,
  [`mi-aem-homepage-spa/components/content/iconfeaturebanner`]: IconFeatureBanner,
  [`mi-aem-homepage-spa/components/content/universal-footer`]: Footer,
  [`mi-aem-homepage-spa/components/content/postcard`]: Postcard,
  [`mi-aem-homepage-spa/components/content/postcardcontainer`]: PostcardContainer,
  [`mi-aem-homepage-spa/components/content/themed-cluster`]: ThemeCluster,
  [`mi-aem-homepage-spa/components/content/cardcarouselcontainer`]: ThemeClusterCarousel,
  [`mi-aem-homepage-spa/components/content/propertybar`]: PropertyBarWrapper,
  [`mcom-book-spa/components/hoteloverlay/hqvmodal`]: HQVModalEditableMGP,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: MerchandisingSmallBanner,
  [`mi-aem-common-spa/components/content/merchandisingherobanner`]: MerchandisingHeroBanner,
  [`mi-aem-common-spa/components/content/dcaabtestwrapper`]: MerchandisingDCAContainer,
  [`mi-aem-common-spa/components/content/protectedcontainer`]: ProtectedContainer,
  [`mi-aem-homepage-spa/components/content/product-detail-cards`]: ProductDetailsCard,
  [`mi-aem-homepage-spa/components/content/sixpackcontainer`]: SixPackContainer,
  [`mi-aem-homepage-spa/components/content/tabbedlayout`]: TabbedLayout,
  [`mi-aem-homepage-spa/components/content/dynamictabbedlayout`]: DynamicTabbedLayout,
  [`mi-aem-homepage-spa/components/content/enrollmentcard`]: EnrollmentCardContainer,
  [`mi-aem-common-spa/components/content/dcadecisioncontainer`]: DCADecisionContainer,
  ['mi-aem-common-spa/components/content/mangopilot']: RiottMediaCard,
  ['mi-aem-common-spa/components/content/riottmediacard']: RiottMediaCard,
  [`mi-aem-common-spa/components/content/tilecarouselcontainer`]: MerchandisingCarouselContainer,
  [`mi-aem-common-spa/components/content/tilesquare`]: MerchandisingCardTile,
  [`mi-aem-common-spa/components/content/animatedbanner`]: CNAnimatedBanner,
  [`mi-aem-shop-spa/components/content/ngsearchformabtestwrapper`]: NGSearchFormABTestWrapper,
  [`mi-aem-common-spa/components/content/globalnav/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-common-spa/components/content/globalnav/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-common-spa/components/content/globalnav/primaryNavigation`]: NavigationWrapper,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawerDynamic,
  [`mi-aem-account/components/content/accountcontainer`]: AccountContainerEditable,
  [`mi-aem-account/components/content/signin`]: SignInEditable,
  [`mi-aem-account/components/content/signincontentblock`]: SignInContentBlockEditable,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
  [`mi-aem-common-spa/components/content/eyebrowbanner`]: MerchandisingEyebrowBanner,
};

export const AEM_REACT_TITLE_MAPPING = {
  ['mi-aem-common-spa/components/content/generalmessage']: 'General Message',
  [`mi-aem-homepage-spa/components/text`]: 'Text',
  [`mi-aem-common-spa/components/common/staticwrapper`]: 'Static Wrapper',
  [`mi-aem-homepage-spa/components/content/herobanner`]: 'Homepage Hero Banner',
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: 'Card Horizontal Mini-Standard',
  [`mi-aem-common-spa/components/content/cardlayered`]: 'Card Layered',
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: 'Card Carousel Container',
  [`mi-aem-common-spa/components/content/cardvertical`]: 'Card Vertical',
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: 'Card Horizontal Feature',
  [`mi-aem-common-spa/components/content/bannerlayered`]: 'Banner Layered',
  [`mi-aem-common-spa/components/content/brandribbon`]: 'Brand Ribbon',
  [`mi-aem-common-spa/components/content/linkbanner`]: 'Link Banner',
  [`mi-aem-common-spa/components/content/linklist`]: 'Link List',
  [`mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch`]: 'Homepage Search',
  [`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`]: 'Baseline Search Form',
  [`mi-aem-shop-spa/components/content/ngsearchform/v1/ngsearchform`]: 'Next Gen Search Form',
  [`mi-aem-common-spa/components/content/iconblock`]: 'Icon Block',
  [`mi-aem-common-spa/components/content/accordioncontainer`]: 'Accordion Container',
  [`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`]: 'Cobrand-Card Horizontal Flexible',
  [`mi-aem-offers-spa/components/offers-cards`]: 'Offers Cards Carousel',
  [`mi-aem-common-spa/components/experiencefragment`]: 'Experience Fragment',
  [`mi-aem-common-spa/components/content/hero`]: 'Hero',
  [`mi-aem-homepage-spa/components/content/iconfeaturebanner`]: 'Icon Feature Banner',
  [`mi-aem-homepage-spa/components/content/universal-footer`]: 'Universal Footer',
  [`mi-aem-homepage-spa/components/content/postcard`]: 'Postcard',
  [`mi-aem-homepage-spa/components/content/postcardcontainer`]: 'Postcard Container',
  [`mi-aem-homepage-spa/components/content/themed-cluster`]: 'Theme Cluster',
  [`mi-aem-homepage-spa/components/content/cardcarouselcontainer`]: 'Card Carousel Component (Theme Cluster)',
  [`mi-aem-homepage-spa/components/content/propertybar`]: 'Property Bar',
  [`mcom-book-spa/components/hoteloverlay/hqvmodal`]: 'HQV Modal',
  [`mi-aem-homepage-spa/components/content/global-navigation`]: 'Global Navigation',
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: 'Utility Navigation',
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: 'Primary Navigation',
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: 'Merchandising Small Banner',
  [`mi-aem-common-spa/components/content/merchandisingherobanner`]: 'Merchandising Hero Banner',
  [`mi-aem-common-spa/components/content/dcaabtestwrapper`]: 'DCA A/B Test Wrapper',
  [`mi-aem-common-spa/components/content/protectedcontainer`]: 'Protected Container',
  [`mi-aem-homepage-spa/components/content/product-detail-cards`]: 'Product Detail Cards',
  [`mi-aem-homepage-spa/components/content/sixpackcontainer`]: 'Six Pack Container',
  [`mi-aem-homepage-spa/components/content/tabbedlayout`]: 'HP Tabbed Layout',
  [`mi-aem-homepage-spa/components/content/dynamictabbedlayout`]: 'HP Dynamic Tabbed Layout',
  [`mi-aem-homepage-spa/components/content/enrollmentcard`]: 'Enrollment Card',
  [`mi-aem-common-spa/components/content/dcadecisioncontainer`]: 'DCA Decision Container',
  ['mi-aem-common-spa/components/content/mangopilot']: 'Mango Pilot',
  ['mi-aem-common-spa/components/content/riottmediacard']: 'Riott Media Card',
  [`mi-aem-common-spa/components/content/tilecarouselcontainer`]: 'Tile Carousel Container',
  [`mi-aem-common-spa/components/content/tilesquare`]: 'Tile Square',
  [`mi-aem-common-spa/components/content/animatedbanner`]: 'Animated Banner',
  [`mi-aem-shop-spa/components/content/ngsearchformabtestwrapper`]: 'Next Gen search form A/B Test Wrapper',
  [`mi-aem-common-spa/components/content/globalnav/global-navigation`]: 'Global Navigation',
  [`mi-aem-common-spa/components/content/globalnav/utilityNavigation`]: 'Utility Navigation',
  [`mi-aem-common-spa/components/content/globalnav/primaryNavigation`]: 'Primary Navigation',
  [`mcom-book-spa/components/flyoutcontainer`]: 'Flyout Container',
  [`mi-aem-account/components/content/accountcontainer`]: 'Account Container',
  [`mi-aem-account/components/content/signin`]: 'Sign In',
  [`mi-aem-account/components/content/signincontentblock`]: 'Sign In Content Block',
  [`mi-aem-account/components/content/datapagecomponent`]: 'Data Page Component',
  [`mi-aem-common-spa/components/content/eyebrowbanner`]: 'Eyebrow Banner',
};

export const getAllowedComponentsForNonAuthorMode = model => {
  return getAllowedComponentsUtil(model, AEM_REACT_MAPPING, AEM_REACT_TITLE_MAPPING);
};

export const defineComponentMapping = (allowedComponents, pagePath, isAuthorMode, pageProps, featureFlags) => {
  const logger = global.loggerInstance?.('defineComponentMapping');
  const log = logger?.log || (() => {});
  const logError = logger?.error || (() => {});

  try {
    const { experience_mcom_carousel_lightining_variants: homepageCarouselFeatureFlags = {} } = featureFlags || {};
    const { carousel_switch_homepage = false } = homepageCarouselFeatureFlags;
    const homepageCarouselFromLightning =
      (pageProps?.query?.lightning === 'true' || carousel_switch_homepage === true) &&
      !pageProps?.requestUri?.includes('/preview');
    MapTo('mi-aem-common-spa/components/content/generalmessage')(GeneralMessage);
    MapTo(`mi-aem-homepage-spa/components/text`)(AEMText);
    MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper);
    MapTo(`mi-aem-homepage-spa/components/content/herobanner`)(HeroBanner);
    MapTo(`mi-aem-homepage-spa/components/content/herobanner`)(props => (
      <HeroBanner {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-common-spa/components/content/cardlayered`)(props => (
      <CardLayered {...props} featureFlagLogo={featureFlags.featureFlagLogo} />
    ));
    MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical);
    MapTo(`mi-aem-common-spa/components/content/linkbanner`)(LinkBanner);
    MapTo(`mi-aem-common-spa/components/content/linklist`)(LinkList);
    MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(
      isAuthorMode ? CardHorizontalMini : CardHorizontalMiniDynamic
    );
    MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(props =>
      isAuthorMode ? (
        <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
      ) : (
        <CardCarouselContainerDynamic {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
      )
    );
    MapTo(`mi-aem-homepage-spa/components/content/themed-cluster`)(props => (
      <ThemeCluster {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mcom-book-spa/components/hoteloverlay/hqvmodal`)(
      props => <HQVModalEditableMGP {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'hqvmodal',
        isEmpty: false,
      }
    );
    MapTo(
      `mi-aem-common-spa/components/hoteloverlay/hotelgalleryoverview`,
      props => (
        <div className={`${props.className} ${props.model.styleclass}`}>
          <HotelOverview {...props.model} {...props} />
        </div>
      ),
      'HotelOverview',
      { isAuthorMode }
    );
    MapTo(
      `mi-aem-common-spa/components/hoteloverlay/hotelinformation`,
      props => (
        <div className={`${props.className} ${props.model.styleclass}`}>
          <HotelInformation {...props.model} {...props} />
        </div>
      ),
      'HotelInformation',
      { isAuthorMode }
    );
    MapTo(
      `mi-aem-common-spa/components/hoteloverlay/hotelgallerytitle`,
      props => (
        <div className={`${props.className} ${props.model.styleclass}`}>
          <HotelGalleryTitle {...props.model} {...props} />
        </div>
      ),
      'HotelGalleryTitle',
      { isAuthorMode }
    );
    MapTo(
      `mi-aem-common-spa/components/hoteloverlay/hotelgalleryphotoviewer`,
      props => (
        <div className={`${props.className} ${props.model.styleclass}`}>
          <HotelGalleryPhotoViewer {...props.model} {...props} />
        </div>
      ),
      'HotelGalleryPhotoViewer',
      { isAuthorMode }
    );
    MapTo(`mi-aem-homepage-spa/components/content/cardcarouselcontainer`)(props => (
      <ThemeClusterCarousel {...props} allowedComponents={allowedComponents} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature);
    MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(isAuthorMode ? BannerLayered : BannerLayeredDynamic);
    MapTo(`mi-aem-common-spa/components/content/brandribbon`)(props => (
      <BrandRibbon {...props} featureFlagLogo={featureFlags.featureFlagLogo} />
    ));
    MapTo(`mi-aem-homepage-spa/components/content/propertybar`)(props => (
      <PropertyBarWrapper {...props} locale={pageProps.currentLocale} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-common-spa/components/content/dcadecisioncontainer`)(
      props => <DCADecisionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
      {
        emptyLabel: 'DCA Wrapper',
        isEmpty: false,
      }
    );
    MapTo('mi-aem-common-spa/components/content/mangopilot')(props => {
      return <RiottMediaCard {...props} isAuthorMode={isAuthorMode} />;
    });

    MapTo('mi-aem-common-spa/components/content/riottmediacard')(props => {
      return <RiottMediaCard {...props} isAuthorMode={isAuthorMode} />;
    });

    MapTo('mi-aem-common-spa/components/content/tilecarouselcontainer')(
      props => <MerchandisingCarouselContainer {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'Tile Carousel Container',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/eyebrowbanner`)(MerchandisingEyebrowBanner, {
      emptyLabel: 'Eyebrow Banner',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/tilesquare`)(MerchandisingCardTile, {
      emptyLabel: 'Tile Square',
      isEmpty: false,
    });
    // Always wrap SearchForm with StickyComponentWrapper; switch behavior by hasGlobalNav
    const getSearchFormComponent = (props, typeOfSearchForm) => {
      const responsivegrid = pageProps.model?.cqItems?.root?.[':items']?.responsivegrid;
      const isNorthStar = pageProps.model.isNorthStarPage || false;
      const hasGlobalNav = Object.values(responsivegrid?.[':items'] || {}).some(c => c.id === 'hp-global-navigation');
      const { POLARIS_TAB_TITLE_ID, SEARCH_FOCUS_EVENT, SEARCH_BLUR_EVENT } = POLARIS_CONSTANTS;

      const handleFocus = () => {
        window.dispatchEvent(new Event(SEARCH_FOCUS_EVENT));
      };
      const handleBlur = () => {
        window.dispatchEvent(new Event(SEARCH_BLUR_EVENT));
      };
      const northStarProps = {
        role: 'group',
        'aria-labelledby': POLARIS_TAB_TITLE_ID,
        onFocus: handleFocus,
        onBlur: handleBlur,
      };

      return hasGlobalNav ? (
        <StickyComponentWrapper
          isNorthStar={isNorthStar}
          {...(isNorthStar && northStarProps)}
          hasGlobalNav={hasGlobalNav}
          {...props}
        >
          {(isSticky, refCallback) =>
            typeOfSearchForm === 'ngsearchform' ? (
              <NGSearchFormEditable
                {...props}
                currentLocale={pageProps.currentLocale}
                isSticky={isSticky}
                isPositionedExternally={true}
                refCallback={refCallback}
              />
            ) : (
              <SearchFormEditable
                {...props}
                currentLocale={pageProps.currentLocale}
                isSticky={isSticky}
                isPositionedExternally={true}
                refCallback={refCallback}
              />
            )
          }
        </StickyComponentWrapper>
      ) : typeOfSearchForm === 'ngsearchform' ? (
        <NGSearchFormEditable {...props} currentLocale={pageProps.currentLocale} />
      ) : (
        <SearchFormEditable {...props} currentLocale={pageProps.currentLocale} />
      );
    };
    MapTo(`mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch`)(props =>
      getSearchFormComponent(props, 'homepagesearch')
    );
    MapTo(`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`)(props =>
      getSearchFormComponent(props, 'baselinesearchform')
    );
    MapTo(`mi-aem-shop-spa/components/content/ngsearchform/v1/ngsearchform`)(props =>
      getSearchFormComponent(props, 'ngsearchform')
    );
    MapTo(`mi-aem-common-spa/components/content/iconblock`)(IconBlock);
    MapTo(`mi-aem-common-spa/components/content/accordioncontainer`)(props => (
      <AccordionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ));
    MapTo(`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`)(CobrandCardHorizontalFlexible);
    MapTo(`mi-aem-offers-spa/components/offers-cards`)(
      props => (
        // Rename to address broken homepage build caused by DXP-7950
        <OfferCardCarousel
          {...props}
          offersData={pageProps.productSpecificResponse}
          isAuthorMode={isAuthorMode}
          acceptLanguage={pageProps?.currentLocale}
          requestId={pageProps?.requestId}
          cookie={pageProps?.headersData['cookie']}
          isLightning={homepageCarouselFromLightning}
        />
      ),
      {
        emptyLabel: 'Offers Card Carousel',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/hero`)(Hero);
    MapTo(`mi-aem-homepage-spa/components/content/iconfeaturebanner`)(IconFeatureBanner);

    MapTo(`mi-aem-homepage-spa/components/content/postcard`)(props => (
      <Postcard {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-homepage-spa/components/content/postcardcontainer`)(props => (
      <PostcardContainer {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(props =>
      isAuthorMode ? (
        <Footer {...props} isAuthorMode={isAuthorMode} />
      ) : (
        <FooterDynamic {...props} isAuthorMode={isAuthorMode} />
      )
    );
    MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(props => (
      <NavigationContainerWrapper
        {...props}
        isAuthorMode={isAuthorMode}
        featureFlagLogo={featureFlags.featureFlagLogo}
        featureFlagLegacyNav={featureFlags.featureFlagLegacyNav}
      />
    ));
    MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper);
    MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper);

    MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
      props => <MerchandisingSmallBanner {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'MerchandesingSmallBanner',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/merchandisingherobanner`)(
      props => (
        <MerchandisingHeroBanner
          {...props}
          isAuthorMode={isAuthorMode}
          featureFlagLogo={featureFlags.featureFlagLogo}
          isHomepage={true}
        />
      ),
      {
        emptyLabel: 'MerchandisingHeroBanner',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/dcaabtestwrapper`)(
      props => (
        <MerchandisingDCAContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
      ),
      {
        emptyLabel: 'DCA AB Test Wrapper',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-shop-spa/components/content/ngsearchformabtestwrapper`)(
      props => (
        <NGSearchFormABTestWrapper {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
      ),
      {
        emptyLabel: 'NGSearchFormABTestWrapper',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/protectedcontainer`)(props => (
      <ProtectedContainer {...props} isAuthorMode={isAuthorMode} />
    ));

    MapTo(`mi-aem-homepage-spa/components/content/product-detail-cards`)(props => (
      <ProductDetailsCard {...props} isAuthorMode={isAuthorMode} />
    ));

    MapTo(`mi-aem-homepage-spa/components/content/sixpackcontainer`)(props => (
      <SixPackContainer {...props} isAuthorMode={isAuthorMode} />
    ));

    MapTo(`mi-aem-homepage-spa/components/content/tabbedlayout`)(props => (
      <TabbedLayout {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-homepage-spa/components/content/dynamictabbedlayout`)(props => (
      <DynamicTabbedLayout {...props} isAuthorMode={isAuthorMode} />
    ));

    MapTo(`mi-aem-homepage-spa/components/content/enrollmentcard`)(props => (
      <EnrollmentCardContainer {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-common-spa/components/content/animatedbanner`)(props => (
      <CNAnimatedBanner {...props} isAuthorMode={isAuthorMode} />
    ));
    // Mapping for Global Navigation components to common-spa
    MapTo(`mi-aem-common-spa/components/content/globalnav/global-navigation`)(props => (
      <NavigationContainerWrapper
        {...props}
        isAuthorMode={isAuthorMode}
        featureFlagLogo={featureFlags.featureFlagLogo}
        featureFlagLegacyNav={featureFlags.featureFlagLegacyNav}
      />
    ));
    MapTo(`mi-aem-common-spa/components/content/globalnav/utilityNavigation`)(NavigationUtilityLinkWrapper);
    MapTo(`mi-aem-common-spa/components/content/globalnav/primaryNavigation`)(NavigationWrapper);

    MapTo(`mcom-book-spa/components/flyoutcontainer`)(
      props => <FlyoutDrawerDynamic {...props.model} {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'FlyoutDrawer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/accountcontainer`)(
      props => <AccountContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'accountcontainer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/signin`)(
      props => <SignInEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signin',
      }
    );
    MapTo(`mi-aem-account/components/content/signincontentblock`)(
      props => <SignInContentBlockEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signincontentblock',
      }
    );
    const DataPageVariationConfig = {
      emptyLabel: 'Data Page',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };
    MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
      const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
      const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
        />
      );
    }, DataPageVariationConfig);

    const existingMappings = Object.keys(AEM_REACT_MAPPING);

    // Validate allowedComponents before processing
    if (allowedComponents && Array.isArray(allowedComponents)) {
      let successCount = 0;
      let failureCount = 0;

      allowedComponents.forEach((mapping, index) => {
        try {
          // Validate mapping object structure
          if (!mapping || typeof mapping !== 'object') {
            throw new Error(`Invalid mapping object at index ${index}`);
          }

          if (!mapping.path || typeof mapping.path !== 'string') {
            throw new Error(`Invalid or missing path in mapping at index ${index}`);
          }

          const baseModelPath = '/jcr:content/root/responsivegrid/';
          const componentPath = mapping.path.replace(pagePath, '').replace(baseModelPath, '');

          if (!componentPath) {
            throw new Error(`Unable to extract component path from: ${mapping.path}`);
          }

          if (existingMappings.indexOf(componentPath) === -1) {
            MapTo(componentPath)(EditableHTLWrapper, {
              emptyLabel: mapping.title || 'Component',
              isEmpty: false,
            });
            successCount++;
          } else {
            if (process.env.NODE_ENV === 'development') {
              log('Mapping already exists, skipping:', componentPath);
            }
          }
        } catch (mappingError) {
          failureCount++;
          if (process.env.NODE_ENV === 'development') {
            logError(`Failed to map component at index ${index}:`, {
              error: mappingError.message,
              mapping: mapping,
              stack: mappingError.stack,
            });
          }
          // Continue processing remaining components
        }
      });

      if (process.env.NODE_ENV === 'development') {
        log(
          `Component mapping complete. Success: ${successCount}, Failed: ${failureCount}, Total: ${allowedComponents.length}`
        );
      }
    } else if (process.env.NODE_ENV === 'development') {
      log('No allowed components provided or invalid format');
    }
  } catch (err) {
    // Always log errors regardless of environment - use your server logger, not console
    logError('Critical error in defineComponentMapping:', {
      error: err.message,
      stack: err.stack,
    });
    // Re-throw so the caller (page bootstrap) can decide recovery strategy.
    // Silent failure here means EVERY AEM component renders as blank with zero observability.
    throw err;
  }
};
